<template>
  <div>
    <b-form-group
      :label="$t('custom_forms.only_img')"
      label-for="onlyImg"
    >
      <b-form-checkbox
        id="onlyImg"
        v-model="onlyImages"
        :checked="false"
        switch
        @change="onInputChange"
      />
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({data: []}),
    },
    config: Object,
  },
  setup(props, {emit}) {
    const onlyImages = ref(false)

    onMounted(async () => {
      onlyImages.value = props.data?.data?.[0]?.onlyImages
    });

    function onInputChange() {
      const payload = {
        onlyImages: onlyImages.value,
      }

      emit("update:data", {
        data: [{...payload}],
      });
    }

    return {
      onlyImages,
      onInputChange,
    };
  },
};
</script>
